// 顶部会话信息小部件 / Top-bar session chip.
// 该区域不再展示用户身份，避免和右侧认证入口重复。
// This area no longer renders identity to avoid duplicating the right-side auth control.

import { $maybe } from "@/lib/dom";

/**
 * 清空顶部 #runtime-status 小部件。
 * Clear the top-bar #runtime-status widget.
 */
export function renderSessionChip(): void {
  const chip = $maybe("runtime-status");
  if (!chip) return;
  chip.textContent = "";
}
